import { withPopup } from '../lib/popup';

import LabelsStep from './LabelsStep';

export default withPopup(LabelsStep);
